var $3d07e46eb4e4df58$exports = {};
$3d07e46eb4e4df58$exports = {
    "maximum": `\u{6700}\u{5927}\u{503C}`,
    "minimum": `\u{6700}\u{5C0F}\u{503C}`
};


export {$3d07e46eb4e4df58$exports as default};
//# sourceMappingURL=zh-TW.mjs.map
